<template lang="pug">
.popup-wrapper(v-show="showPopup")
  .popup-background(@click="closePopup")
  .popup
    .popup-header BOG SNORT
    .popup-text If you are seriously using this app, then you seriously need help
    .popup-links
      .close(@click="closePopup") Close
      .help(@click="goToHelp") Help
</template>

<script>

export default {
  name: 'Popup',
  components: {
  },
  data () {
    return {
      showPopup: true
    }
  },
  methods: {
    closePopup () {
      this.showPopup = !this.showPopup
      localStorage.setItem('popupShowed', 'true')
    },
    goToHelp () {
      this.closePopup()
      this.$router.push({ name: 'help' })
    }
  },
  async created () {
  }
}
</script>

<style lang="stylus" scoped>
.popup-wrapper
  display flex
  align-items center
  justify-content center
  position fixed
  z-index 1
  left 0
  top 0
  width 100%
  height 100%
  overflow auto
.popup-background
  position: absolute
  top 0
  left 0
  right 0
  bottom 0
  width 100%
  height 100%
.popup
  z-index 9998
  width 320px
  height 320px
  background url('~/img/popup-background.png')
  background-size contain
  background-repeat no-repeat
  padding-top 60px
  color rgb(0, 0, 0)
  text-align center
.popup-header
  margin-left -50px
  transform rotate(-5deg)
  font-family 'JEMBOhands'
  font-size 21px
  font-weight bold
  margin-bottom 98px
.popup-text
  transform rotate(-10deg)
  font-size 13px
  padding-left 45px
  padding-right 50px
.popup-links
  transform rotate(-10deg)
  display block
  padding-left 20px
.close
.help
  font-size 15px
  text-transform uppercase
  text-decoration underline
  color rgb(0, 0, 0)
  cursor pointer
  display inline-block
  vertical-align middle
  padding 4px 6px
.help
  transform rotate(2deg)
</style>
